import {ChangeDetectionStrategy, Component, Injectable, input, Signal} from "@angular/core";
import {AgendaelementId, OppgaveModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {Observable, switchMap} from "rxjs";
import {takeUntilDestroyed, toObservable, toSignal} from "@angular/core/rxjs-interop";
import {OppgaveDatatjeneste} from "felles-ng2/tjenester/datalager/OppgaveDatatjeneste";
import {OppgavelisteKompaktKomponent} from "web-ng2/moduler/oppgave/komponenter/oppgaveliste-kompakt/oppgaveliste-kompakt";

const debug = initDebugger('SakListeOppgaverKomponent');

/**
 * Lister oppgaver knyttet til sak
 */
@Component({
    selector: 'sak-liste-oppgaver',
    host: {'data-testid': 'sak-liste-oppgaver'},
    templateUrl: 'sak-liste-oppgaver.html',
    styleUrl: 'sak-liste-oppgaver.scss',
    imports: [
        OppgavelisteKompaktKomponent
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SakListeOppgaverKomponent {
    static ajsSelector = 'sakListeOppgaver';

    sakId = input.required<AgendaelementId>();
    oppgaver:Signal<OppgaveModell[]>;

    constructor(private avhengigheter: SakListeOppgaverKomponentAvhengigheter) {
        this.oppgaver = toSignal(toObservable(this.sakId)
          .pipe(
            switchMap(id => this.avhengigheter.oppgaver(id)),
            takeUntilDestroyed()),
          {initialValue: []});
    }
}

@Injectable()
export class SakListeOppgaverKomponentAvhengigheter {

    constructor(private oppgaveDatatjeneste:OppgaveDatatjeneste) {
    }

    oppgaver(id:AgendaelementId): Observable<OppgaveModell[]> {
        return this.oppgaveDatatjeneste.finnTilknyttetSakFraLokallager(id);
    }
}
